export class Ledger {
  constructor(
    public readonly id: string,
    public readonly code: string,
    public readonly type: string,
    public readonly description: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): Ledger {
    return new Ledger(
      json['id'],
      String(json['code']),
      json['type'],
      json['description'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}